import { createContext } from "react";
import { Plano } from "../../types/Plano";

export type IntegracaoContextType = {
    chaveIntegracao: string;
    setChaveIntegracao: (chave: string) => void;
    activeChaveIntegracao: boolean;
    setActiveChaveIntegracao: (active: boolean) => void;
    onChangeIntegracao: (newValue: boolean) => void;
    onChangeIntegracaoTiny: (newValue: boolean) => Promise<void | false>;
    onChangeIntegracaoBling: (newValue: boolean) => Promise<void | false>;
    onChangeIntegracaoBlingV2: (newValue: boolean) => Promise<void | false>;
};

export const IntegracaoContext = createContext<IntegracaoContextType>(null!);